module.exports = __webpack_public_path__ + "img/business-and-finance-3.dd1c847b.png";